<template>
	<div>
		<h1 v-if="Object.keys(this.contents).length > 0">Basket</h1>
		<div class="basket_message" v-if="1==2 && Object.keys(this.contents).length > 0">
			<p><i class="fal fa-exclamation-triangle fa-3x"></i> Please note: Every effort is made to achieve the chosen delivery date by our delivery partner Pallet Track, but occasionally some depots are affected by the need to adhere to the government guidelines on track and trace which can lead to small delays.</p>
		</div>
		<div class="basket_wrapper">
			<template v-if="Object.keys(this.contents).length > 0">
				<div class="shopping_basket_details">
					<table width="100%" cellpadding="0" cellspacing="0" border="0" class="shopping_basket_table">
						<tr v-for="item in contents" v-bind:key="item.id">
							<td class="image">
								<img :src="item['model']['product']['thumbnail_image']" width="100" height="100" :alt="getModelField(item,'nameField')">
							</td>
							<td class="name">
								<p class="name">
									<a :href="getModelField(item,'slugField')">{{ getModelField(item,'nameField') }}</a>
									<br>{{ getModelField(item,'descriptionField') }}
                                    <template v-if="item.model.attributes && item.model.attributes.length > 0 && item.model.is_sample == false">
                                        <template v-for="attribute in item.model.attributes">
                                            <br>{{ attribute.attribute_group.name }}: {{ attribute.name }}
                                         </template>
                                    </template>
								</p>
								<p class="price">
									{{ getDisplayPrice(item.model, item.quantity) }}
									<sup>*</sup>
								</p>
							</td>
							<td class="quantity">
								<div class="quantity_wrapper">
									<button type="button" v-on:click="updateQty(item, (item.model.tile_area > 0 ? 0 - item.model.tile_area : -1))" class="decrease"><i class="fal fa-fw fa-minus"></i></button>
									<input type="number" :min="item.model.tile_area > 0 ? item.model.tile_area : 1" max="5000" :step="item.model.product.use_per_meter_pricing ? (item.model.tile_area > 0 ? item.model.tile_area : '0.01') : '1'" name="quantity" class="quantity" v-model="item.quantity" v-on:keydown.enter.prevent v-on:input="debounceinputQuantity(item)">
									<span class="meter" v-if="item.model.is_sample==0 && item.model.product['use_per_meter_pricing']">m<sup><small>2</small></sup></span>
									<button type="button" v-on:click="updateQty(item, (item.model.tile_area > 0 ? item.model.tile_area : 1) )" class="increase"><i class="fal fa-fw fa-plus"></i></button>
								</div>
								<template v-if="item.model.product.use_per_meter_pricing && item.model.tile_area > 0">
									<small>This will give you {{ calculate_tiles(item) }}</small>
								</template>
							</td>
							<td class="remove">
								<button type="button" v-on:click="removeBasketItem(item.id)">Remove</button>
								<button type="button" v-on:click="saveForLater(item.id)">Save for later</button>
							</td>
						</tr>
					</table>
					<div style="flex: 0 0 100%">
						<br><br>

						<template v-if="Object.keys(this.also_needs).length > 0">
							<h3 style="margin-bottom: 0;">You might also need</h3>
							<table cellpadding="0" cellspacing="0" border="0" class="also_buy also_need">
								<tr v-for="variation in also_needs">
									<td><img :src="variation.product.thumbnail_image" width="80" height="80" :alt="variation.full_name"></td>
									<td>
										<a :href="variation.product.full_slug" target="_blank">{{ variation.full_name }}</a> x {{ variation.qty }}
										<template v-if="variation.product.calculator_type=='grout'">
											<br><small>Suggested quantity based on a tile spacing of 5mm</small>
										</template>
										<template v-if="variation.product.calculator_type=='primer'">
											<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup></small>
										</template>
										<template v-if="variation.product.calculator_type=='membrane'">
											<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup> per roll</small>
										</template>
									</td>
									<td>
										<template v-if="variation.product['use_per_meter_pricing']==1 && variation.is_sample == 0">
											from
											<b>{{ getDisplayPrice(variation, 1) }}<sup>*</sup></b>
											per m<sup><small>2</small></sup>
											<span style="font-size: 0.8em; display: block;">when you buy {{ variation.coverage }}m<sup>2</sup>&nbsp; or more</span>
										</template>
										<template v-else>
											<b>{{ getDisplayPrice(variation, variation.qty) }}<sup>*</sup></b>
											<template v-if="variation.product.show_equivalent_price && variation.pricing['variation_equivalent_m2'] > 0">
												<span class="equivalent">{{ format_currency(addVat(variation.pricing['variation_equivalent_m2'])) }}<sup>*</sup> per m<sup><small>2</small></sup></span>
											</template>
										</template>
									</td>
									<td>
										<button type="button" class="button medium solid green" v-on:click.prevent="addToBasket(variation, variation.qty)"> <i class="fas fa-fw fa-shopping-basket"></i> Add</button>
									</td>
								</tr>
							</table>
						</template>


						<template v-if="Object.keys(this.also_buys).length > 0">
							<h3 style="margin-bottom: 0;">You might also want</h3>
							<table cellpadding="0" cellspacing="0" border="0" class="also_buy">
								<tr v-for="variation in also_buys">
									<td><img :src="variation.product.thumbnail_image" width="80" height="80" :alt="variation.full_name"></td>
									<td>
										<a :href="variation.product.full_slug" target="_blank">{{ variation.full_name }}</a> x {{ variation.qty }}
										<template v-if="variation.product.calculator_type=='grout'">
											<br><small>Suggested quantity based on a tile spacing of 5mm</small>
										</template>
										<template v-if="variation.product.calculator_type=='primer'">
											<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup></small>
										</template>
										<template v-if="variation.product.calculator_type=='membrane'">
											<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup> per roll</small>
										</template>
									</td>
									<td>
										<template v-if="variation.product['use_per_meter_pricing']==1 && variation.is_sample == 0">
											from
											<b>{{ getDisplayPrice(variation, 1) }}<sup>*</sup></b>
											per m<sup><small>2</small></sup>
											<span style="font-size: 0.8em; display: block;">when you buy {{ variation.coverage }}m<sup>2</sup>&nbsp; or more</span>
										</template>
										<template v-else>
											<b>{{ getDisplayPrice(variation, variation.qty) }}<sup>*</sup></b>
											<template v-if="variation.product.show_equivalent_price && variation.pricing['variation_equivalent_m2'] > 0">
												<span class="equivalent">{{ format_currency(addVat(variation.pricing['variation_equivalent_m2'])) }}<sup>*</sup> per m<sup><small>2</small></sup></span>
											</template>
										</template>
									</td>
									<td>
										<button type="button" class="button medium solid green" v-on:click.prevent="addToBasket(variation, variation.qty)"> <i class="fas fa-fw fa-shopping-basket"></i> Add</button>
									</td>
								</tr>
							</table>
						</template>
						<p><a :href="this.continue_destination" class="button upper solid primary back_arrow">Continue Shopping</a></p>
						<p>
						* Product prices include VAT.
						</p>
					</div>
				</div>
				<div class="shopping_basket_summary">

					<div class="shipping_options">
						<h2>Delivery service</h2>

						<template v-if="preselected_postcode==''">
							<p><small>Please enter your postcode to find suitable delivery services</small></p>
							<form action="/set-postcode" method="post" class="postcode_form">
								<input type="text" name="postcode" v-model="postcode" placeholder="Enter postcode">
								<input type="hidden" name="redirect" value="/basket">
								<input type="hidden" name="_token" :value="csrf">
								<button type="submit" class="button solid small primary">SUBMIT</button>
							</form>
						</template>

						<template v-else>

							<template v-if="Object.keys(shipping_services).length == 0">
								<p>There are no shipping services available for your location.</p>
							</template>
							<template v-if="this.variation_count > this.sample_count">
								<p v-for="service in shipping_services">
									<label>
									<input type="radio" :value="service.id" v-model="selected_service_id">
										{{ service.name }}

											<span>&pound;{{ addVat(parseFloat(service.cost)).toFixed(2) }} </span>
											<template v-if="service['dates'].length == 1">
												<br>
												<small>
													{{ service['dates'][0][1] }}
													<template v-if="selected_delivery_date_extra">
														{{ selected_delivery_date_extra }}
													</template>
												</small>
											</template>
											<br><small>
												inc VAT
											</small>

									</label>
								</p>

								<template v-if="Object.keys(service_dates).length > 1">
									<p>
										<label>Choose your delivery day</label>
										<span class="select_wrapper" >
											<select class="styled_select" v-model="selected_delivery_date" v-on:change="updateDeliveryDate()">
												<option v-for="date in service_dates" :value="date[0]">{{ date[1] }}</option>
											</select>
										</span>
									</p>
								</template>

								<p v-if="preselected_postcode!=''">
									<small>Delivery to {{ this.preselected_postcode }} - <button type="button" v-on:click="togglePostcode()">change postcode</button></small><br>
									<template v-if="this.sample_count > 0">
										<small>Aggregate and Tile samples are delivered via the parcel network. Veneer sheet slips are mailed.</small><br>
									</template>
									<br><small><strong>{{  service_description }}</strong></small>
								</p>
								<form action="/set-postcode" method="post" class="postcode_form" v-if="this.show_postcode_form==true">
									<input type="text" name="postcode" v-model="postcode" placeholder="Enter postcode">
									<input type="hidden" name="redirect" value="/basket">
									<input type="hidden" name="_token" :value="csrf">
									<button type="submit" class="button solid small primary">SUBMIT</button>
								</form>

								<template v-if="supplier_count > 1">
									<p><small>Your order is DIRECT from the quarry and comes from more than one location.</small></p>
								</template>
							</template>
							<template v-else>
								<p>Aggregate and Tile samples are delivered via the parcel network. Veneer sheet slips are mailed.</p>
							</template>
						</template>

						<p class="delivery_message">For more information, please check out our <a href="/delivery" target="_blank">delivery</a> page</p>
					</div>

					<div class="basket_totals">
						<template v-if="this.calculating==true">
							<div class="calculating"><i class="fas fa-spinner fa-spin"></i></div>
						</template>
						<p>
							<span class="label">
								Item Total
								<br><small>inc VAT</small>
							</span>
							<span class="value">
								{{ format_currency(parseFloat(this.itemTotal.toFixed(2))) }}
							</span>

						</p>
						<p>
							<span class="label">
								Delivery
								<template v-if="Object.keys(shipping_services).length > 0 && parseFloat(this.shippingTotal).toFixed(2) > 0">
									<br><small>inc VAT</small>
								</template>
							</span>
							<span class="value">
								<template v-if="Object.keys(shipping_services).length == 0">
									Unavailable
								</template>
								<template v-else>
									<template v-if="parseFloat(this.shippingTotal.toFixed(2)) > 0">
										{{ format_currency(addVat(parseFloat(this.shippingTotal.toFixed(2)))) }}
									</template>
									<template v-else>
										<template v-if="preselected_postcode==''">Enter your postcode to view delivery options</template>
										<template v-else>Included</template>
									</template>
								</template>
							</span>


							<span class="itemised_delivery" v-if="preselected_postcode!='' && Object.keys(this.contents).length > 1">
								<span class="itemised_delivery_line" v-for="(price, shipping_product) in shipping_products">
									{{ shipping_product }} <b>
										<template v-if="parseFloat(price.price) == 0">Included</template>
										<template v-else>{{ format_currency(addVat(parseFloat(price.price.toFixed(2)))) }}</template>
									</b>
								</span>
							</span>

						</p>
						<p v-if="this.discountTotal > 0">
							<span class="label">
								Discount
								<br><small>{{ this.discountDescription }}</small>
								<br><small>inc VAT</small>
								<br><small><a id="remove_discount" v-on:click="removeDiscount()">[remove]</a></small>
							</span>
							<span class="value">
								{{ format_currency(addVat(parseFloat(this.discountTotal.toFixed(2)))) }}
							</span>
						</p>
						<p>
							<span class="label">
								Total To Pay
								<br><small>includes {{ format_currency(parseFloat(taxTotal.toFixed(2))) }} VAT</small>
							</span>
							<span class="value">
								{{ format_currency(parseFloat(this.orderTotal.toFixed(2))) }}
							</span>
						</p>
					</div>

					<div class="discount_code" v-if="preselected_postcode !='' && this.discountTotal <= 0">
						<p v-on:click="toggleCode()">I have a discount code</p>
						<p v-if="show_form==true">
							<input type="text" name="discount_code" v-model="discount_code" placeholder="Enter code" v-on:keydown.enter.prevent="applyCode">
							<button type="button" class="button solid small" v-on:click="applyCode">Apply</button>
						</p>
					</div>

					<button type="button" class="button wide upper solid green arrow" v-on:click="postBasket" :disabled="Object.keys(shipping_services).length == 0">Proceed to Checkout</button>

				</div>

			</template>
			<template v-else>
				<h1>Your basket is empty</h1>
			</template>
		</div>

		<section class="saved_for_later inspiration_products card_list six_column square_image" style="margin-top: 0;" v-if="working_saved_list != null && Object.keys(working_saved_list).length > 0 && Object.keys(working_saved_list.items).length > 0">

			<h2 style="text-align: left;">Saved For Later</h2>

			<div class="grid">

				<div class="list_item" v-for="item in working_saved_list.items">
					<div class="image" :style="'background-image: url(' + item.variation.product.thumbnail_image + ');'">
						<img :src="item.variation.product.thumbnail_image" alt="NAME" />
					</div>
					<div class="text">
						<h2><a :href="item.variation.full_slug">{{ item.variation.product.name }}<br><small>{{ item.variation.name }}</small></a></h2>
						<p>x {{ item.quantity + '' }}</p>

						<template v-if="item.variation.pricing.selling_price > 0 && item.variation.pricing.shipping_rate >= 0">
							<p>
								<template v-if="item.variation.product['use_per_meter_pricing'] == 1 && item.variation.is_sample == 0">
									<template v-if="item.quantity <= item.variation['coverage']">
										<b>{{ getDisplayPrice(item.variation, item.quantity) }}</b>
										<sup>*</sup>
									</template>
									<template v-else>
										<b>{{ getDisplayPrice(item.variation, item.quantity) }}</b>
										<sup>*</sup>
									</template>
								</template>
								<template v-else>
									<b>{{ getDisplayPrice(item.variation, item.quantity) }}</b>
									<sup>*</sup>
								</template>
							</p>
						</template>
						<p v-else-if="postcode==''">
							Enter a postcode for pricing
						</p>
						<p v-else>
							Not available for delivery to <strong>{{ session('pricing_postcode') }}</strong>
						</p>

						<p class="buttons">
							<button type="button" v-on:click.prevent="moveToBasket(item)">Move to basket</button>
							<button type="button" v-on:click.prevent="removeFromSavedList(item.id)">Remove</button>
						</p>

					</div>
				</div>

			</div>
		</section>
		<section class="saved_for_later" v-else-if="logged_in == false">
			<h2 style="text-align: left;">Saved For Later</h2>
			<button type="button" class="button solid upper primary" v-on:click.prevent="retrieveSavedList()">Retrieve Saved List</button>
		</section>
	</div>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';
export default {

	directives: {debounce},

	props: [
		'preselected_postcode',
		'destination',
		'continue_destination',
		'logged_in',
		'saved_list'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			contents: [],
			also_buys: [],
			also_needs: [],
			itemTotal: 0,
			itemTax: 0,

			shippingTax: 0,
			shippingTotal: 0,
			taxTotal: 0,
			discountTotal: 0,
			orderTotal: 0,
			discountDescription: null,
			discount_code: null,
			service_description : '',
			service_dates : {},
			shipping_services: [],
			selected_service_id: null,
			selected_delivery_date: 'blah',
			shipping_products: {},
			show_form: false,

			calculating: false,

			show_postcode_form: false,
			postcode: '',

			variation_count: 0,
			sample_count: 0,
			supplier_count: 0,

			discount_qualified: false,

			working_saved_list: null
		}
	},

	computed: {
		selected_delivery_date_extra: function () {
			if (this.selected_delivery_date == null || this.selected_service_id == null) { return null; }
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					var service = this.shipping_services[key];
					if (service['dates'].length == 1 && service['name'] == 'Standard') {
						return '(estimated)';
					}
				}
			}
			return null;
		}
	},

	watch: {
		selected_service_id: function(value) {
			this.selected_delivery_date = null;
			// loop through the shipping services to find the details that correspond to the id being passed in above
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					// got it
					this.service_description = this.shipping_services[key]['description'];
					// if the service allows nominated day then get the dates from the service
					if (this.shipping_services[key]['id']==2 && this.shipping_services[key]['allow_nominated_day']==0) {
						this.service_dates = {};
						this.selected_delivery_date = null;
					}else{
						this.service_dates = this.shipping_services[key]['dates'];
						// if there are dates
						if(Object.keys(this.service_dates).length != 0){
							// and there isn't already one selected then select the first
							if(this.selected_delivery_date==null) {
								this.selected_delivery_date = this.shipping_services[key]['dates'][0][0];
							}else{
							}
						}else{
							this.selected_delivery_date = null;
						}
					}
				}
			}

			this.updateShippingDetails(value, this.selected_delivery_date, this.selected_delivery_date_extra);
		},
	},

	mounted() {
		this.getBasketContents();
		this.working_saved_list = this.saved_list;
	},

	methods: {
		// Map the Methods from the State Module
		//...mapActions(['minicartRefresh']),

		getBasketContents: function() {
			this.discount_qualified = false;
			axios.get('/ajax/getBasketContents')
			.then(response => {
				this.getShippingServices();
				this.sample_count = 0;
				this.contents = response.data.basket;
				this.also_buys = response.data.also_buys;
				this.also_needs = response.data.also_needs;
				var self = this;
				this.$nextTick(function() {
					self.variation_count = self.contents.length;
					var suppliers = [];
					for (var key in self.contents) {
						// count samples
						if(self.contents[key]['model']['is_sample'] == 1) {
							self.sample_count++;
						}else{
							// count non-sample suppliers
							suppliers.push(self.contents[key]['model']['product']['supplier_id']);
							// is this a discount qualifier?
							if(self.contents[key]['model']['product']['discount_qualifier'] == 1) {
								self.discount_qualified = true;
							}
						}

					}
					let unique_suppliers = [...new Set(suppliers)];
					this.supplier_count = unique_suppliers.length;
					this.updateAlsoQtys();
				});
			})
			.catch(error => {
			});
		},

		updateQty: function(item,change) {

			var stock = this.getModelField(item,'stockField');
			var newQty = Number(item.quantity) + Number(change);

			if (newQty < ( Number(item.model.tile_area) > 0 ? Number(item.model.tile_area) : 1 )) {
				newQty = (Number(item.model.tile_area) > 0 ? Number(item.model.tile_area) : 1 );
				return;
			};
			if (stock != null) {
				if (newQty > stock) {
					newQty = stock;
					alert("There is not enough stock for that.");
				}
			}
			if (newQty > 0) {
				item.quantity = newQty;
				this.inputQuantity(item);
			}
		},


		debounceinputQuantity:  debounce(function(item) {
			this.inputQuantity(item);
		},500),

		inputQuantity:  function(item) {
			//item.quantity = (+item.quantity);
			item.quantity = parseFloat(Number(item.quantity).toFixed(2));
			var stock = this.getModelField(item,'stockField');
			// donot compute empty value or string
			if ($.isNumeric(item.quantity) === false) {
				return false;
			}

			if (!item.model.product.use_per_meter_pricing || item.model.is_sample) {
				if(!Number.isInteger(item.quantity) ) {
					item.quantity = Math.floor(item.quantity).toFixed(0);
				}else{
					item.quantity = (item.quantity).toFixed(0);
				}
				// force the minimum value to 1
				if ($.isNumeric(item.quantity) === true && item.quantity < 1) {
					item.quantity = 1;
				}
			}else{
				if ($.isNumeric(item.quantity) === true && item.quantity <= Number(item.model.tile_area)) {
					item.quantity = Number(item.model.tile_area) > 0 ? Number(item.model.tile_area) : 1;
				}
				if(Number(item.model.tile_area) > 0) {
					if(!Number.isInteger( Number((item.quantity / Number(item.model.tile_area)).toFixed(6))  )) {
						item.quantity = parseFloat(
							(Math.floor(item.quantity / Number(item.model.tile_area)) + 1)
							*
							Number(item.model.tile_area)
						).toFixed(2);
					}
				}
			}


			// check stock
			if (stock != null) {
				if (item.quantity > stock) {
					item.quantity = stock;
				}
			}
			this.updateAlsoQtys();
			// update the basket
			this.updateBasketItem(item);
		},

		updateBasketItem: function(item) {
			axios.post('/box/basket/update', {
				id: item.id,
				quantity: item.quantity
			})
			.then(response => {
				if(item.model.is_sample) {
					this.getBasketContents();

					this.getTotals();
					return;
				}
				this.getShippingServices();
				this.$store.commit('updateMinicartRefreshStatus', true);
				if (response.data != '') {
					alert(response.data);
				}

			})
			.catch(error => {
				console.log(error);
			});
		},

		removeBasketItem: function(id) {
			if (confirm("Are you sure you want to remove this item?")) {
				axios.post('/box/basket/remove', {
					id: id
				})
				.then(response => {
					if (response.data === 'success') {
						this.getBasketContents();
						this.getTotals();
						this.$store.commit('updateMinicartRefreshStatus', true);
					}else{
					}
				})
				.catch(error => {
					console.log(error);
				});
			}
		},

		addToBasket: function(variation, qty = 1) {
			//var qty = 1;
			if (variation.product.use_per_meter_pricing == 1 && variation.dimension_x > 0 && variation.dimension_y > 0) {
				if (qty == 1) { qty = Math.ceil( 1 / variation.tile_area ) * variation.tile_area; }
			}

			axios.post('/box/basket/add', {
				Model_Type: '\\App\\Variation',
				Model_Id: variation.id,
				Quantity: qty,
				FreeTypeAttributes: ''
			}).then((response) => {

				this.getBasketContents();
				this.getTotals();
				this.$store.commit('updateMinicartRefreshStatus', true);
			});


		},

		getShippingServices: function() {
			axios.get('/ajax/getShippingServices')
				.then(response => {
				this.shipping_services = response.data.services;
				if(response.data.selected_service_id == null) {
					this.selected_service_id = null;
					return;
				}
				this.selected_delivery_date = response.data.selected_delivery_date;
				this.selected_service_id = response.data.selected_service_id;

				for (var key in this.shipping_services) {
					if (this.shipping_services[key]['id'] == this.selected_service_id) {
						this.service_description = this.shipping_services[key]['description'];
						if (this.shipping_services[key]['id']==2 && this.shipping_services[key]['allow_nominated_day']==0) {
							this.service_dates = {};
						}else{
							this.service_dates = this.shipping_services[key]['dates'];
						}

						//if(this.shipping_services[key]['allow_nominated_day']==1){
							//this.service_dates = this.shipping_services[key]['dates'];
						//}else{
						//	this.service_dates = {};
						//}
					}
				}

				this.getTotals();
			})
			.catch(error => {
			});
		},

		updateDeliveryDate: function(delivery_date) {
			this.updateShippingDetails(this.selected_service_id, this.selected_delivery_date, this.selected_delivery_date_extra);
		},

		updateShippingDetails: function(shipping_service_id, delivery_date, delivery_extra) {
			axios.post('/ajax/setShippingService', {
				shipping_service_id: shipping_service_id,
				delivery_date: delivery_date,
				delivery_extra: delivery_extra
			})
			.then(response => {
				if (response.data.status=='ok') {
					this.$nextTick(function() {
						this.getTotals();
					});

				}else{
					alert(response.data.error);
				}
			})
			.catch(error => {
			});
		},

		getShippingTotal: function () {
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					this.shippingTotal = this.shipping_services[key]['cost'];
					this.shipping_products = this.shipping_services[key]['products']
				}
			}
		},

		rateDifference: function(valuetocompare) {
			var default_rate = 0;
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['default'] == 1) {
					default_rate = this.shipping_services[key]['cost'];
				}
			}
			return valuetocompare - default_rate;
		},

		getTotals: function(){
			axios.get('/ajax/getItemTotal')
			.then(response => {
				var itemTotalInc = parseFloat(response.data.inc);
				var itemTotalExc = parseFloat(response.data.exc);
				this.itemTotal = itemTotalInc;

				axios.get('/ajax/getDiscount')
				.then(response => {

					this.discountTotal = response.data.value;
					this.discountDescription = response.data.description;

					this.getShippingTotal();

					var subtotal = parseFloat(itemTotalExc.toFixed(2)) + parseFloat(this.shippingTotal.toFixed(2)) - parseFloat(response.data.value.toFixed(2));
					var subtotal_inc = parseFloat(itemTotalInc) + this.addVat(this.shippingTotal) - this.addVat(response.data.value);
					this.taxTotal = subtotal_inc - subtotal;

					this.orderTotal = subtotal_inc;

				})
				.catch(error => {
				});
			})
			.catch(error => {
			});
		},
		calculateTotals: function() {
			var subtotal = (parseFloat(this.itemTotal) + parseFloat(this.shippingTotal) - parseFloat(this.discountTotal)).toFixed(2);
			this.taxTotal = this.addVat(subtotal) - subtotal;
			this.orderTotal = parseFloat(this.itemTotal) +
							parseFloat(this.shippingTotal) +
							parseFloat(this.taxTotal)
							- parseFloat(this.discountTotal);
		},

		applyCode: function(e){
			e.preventDefault();
			axios.post('/ajax/applyDiscountCode', {
				discount_code: this.discount_code
			})
			.then(response => {
				if (response.data.status=='ok') {
					this.getTotals();
				}else{
					alert(response.data.error);
				}
			})
			.catch(error => {
			});
			return false;
		},

		removeDiscount: function() {
			axios.get('/ajax/removeDiscountCode')
			.then(response => {
				this.getTotals();
			})
			.catch(error => {
			});
		},

		toggleCode: function() {
			this.show_form = !this.show_form;
		},

		togglePostcode: function() {
			this.show_postcode_form = !this.show_postcode_form;
		},

		applyPostcode: function(e){
			e.preventDefault();
			axios.post('/set-postcode', {
				postcode: this.postcode,
				redirect: '/basket'
			})
			.then(response => {
				if (response.data.status=='ok') {
					window.location.reload();
				}else{
					alert(response.data.error);
				}
			})
			.catch(error => {
			});
		},

		postBasket: function() {
			window.location.href = this.destination;
		},

		getModelField: function(item, field) {
			return item.model[JSON.parse(item.field_info)[field]]
		},

		addVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var multiply_by = 1 + (rate / 100);
			return parseFloat((num * multiply_by).toFixed(2));
		},

		removeVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var divide_by = 1 + (rate / 100);
			return num / divide_by;
		},

		calculate_tiles: function(item) {
			var tiles = Number((item.quantity / Number(item.model.tile_area)).toFixed(0));
			return tiles + ' tile' + (tiles != 1 ? 's' : '');
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (value + 0.0001) * 100 ) / 100).toFixed(2));
		},

		getDisplayPrice: function (variation, qty) {
			var price = '';
			if(variation.product['use_per_meter_pricing']==1 && variation.is_sample == 0){
				if (+qty <= +variation.coverage) {
					if (variation.product.discountable == 1 && this.discount_qualified) {
						price = this.format_currency(
							(this.addVat(variation.pricing['product_portion']) * qty)
						);
					} else {
						price = this.format_currency(
							(this.addVat(variation.pricing['product_portion']) * qty)
							+
							(this.addVat(variation.pricing['delivery_portion']))
						);
					}
				}else{
					if (variation.product.discountable == 1 && this.discount_qualified) {
						price = this.format_currency(this.addVat(variation.pricing['product_portion']) * qty);
					} else {
						price = this.format_currency(this.addVat(variation.pricing['selling_from_price']) * qty);
						console.log(variation.pricing['selling_from_price']);
					}
				}
			}else{
				if (variation.product.discountable == 1 && this.discount_qualified) {
					price = this.format_currency(this.addVat(variation.pricing['product_portion']) * qty);
				} else {
					price = this.format_currency(this.addVat(variation.pricing['selling_price']) * qty);
				}
			}
			return price;
		},

		updateAlsoQtys: function(){

			// loop through basket
			var total_grout_required = 0;
			var total_primer_required = 0;
			var total_membrane_required = 0;

			// calculate how much grout, primer and membrane is required
			for (var key in this.contents) {
				var basket_item = this.contents[key].model;
				if (basket_item.product.use_per_meter_pricing == 1 && basket_item.dimension_x > 0 && basket_item.dimension_y > 0) {

					// grout calculation
					var grout_a = basket_item.dimension_x + basket_item.dimension_y;
					var grout_b = 5 * 20;
					var grout_c = grout_a * grout_b * 2;
					var grout_d = basket_item.dimension_x * basket_item.dimension_y;
					var grout_e = grout_c / grout_d;
					var grout_f = grout_e * this.contents[key].quantity;
					total_grout_required += grout_f;

					// primer calculation
					total_primer_required += this.contents[key].quantity;
				}
				if(basket_item.product.calculator_type=='combo_volume') {
					var prod_coverage = basket_item.coverage;
					total_membrane_required += (basket_item.coverage * this.contents[key].quantity);
				}
			}

			for (var key in this.also_needs) {
				var variation = this.also_needs[key];
				if(variation.product.calculator_type=='grout') {
					var newqty = Math.ceil(total_grout_required / variation.weight);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='primer') {
					var newqty = Math.ceil(total_primer_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='membrane') {
					var newqty = Math.ceil(total_membrane_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
			}

			for (var key in this.also_buys) {
				var variation = this.also_buys[key];
				if(variation.product.calculator_type=='grout') {
					var newqty = Math.ceil(total_grout_required / variation.weight);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='primer') {
					var newqty = Math.ceil(total_primer_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='membrane') {
					var newqty = Math.ceil(total_membrane_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
			}

		},

		retrieveSavedList: function() {
			var self = this;
			var content = 'Please enter the email address used when saving the list<br><input type="text" placeholder="your_email@address.com" class="jconfirm-input email_address" required>';
			$.confirm({
				title: '',
				content: content,
				buttons: {
					Cancel: {
					},
					Submit: {
						btnClass: 'btn-green',
						action: function () {
							var email_address = this.$content.find('.email_address').val();
							if(email_address == '') {
								$.alert({
								title: 'Error',
								type: 'red',
								content: 'Please enter an email address',
								buttons: {
									OK: function () {
									},
								}
								});
								return false;
							}else{

								axios.post('/ajax/retrieveSavedList', {
									email_address: email_address
								})
								.then(response => {
									if (response.data.status == 'success') {
										self.working_saved_list = response.data.saved_list;
									}
									if (response.data.status == 'error') {
										$.alert({
											title: 'Error',
											type: 'red',
											content: response.data.msg,
											buttons: {
												OK: function () {
												},
											}
										});
									}
								})
								.catch(error => {
									console.log(error);
								});

							}
						}
					}
				}
			});
		},

		saveForLater: function(item_id){
			var self = this;
			var email_address = '';

			var ask_for_email = !this.logged_in && !this.working_saved_list;

			if (ask_for_email) {
				var content = 'Please enter your email address<br><input type="text" placeholder="your_email@address.com" class="jconfirm-input email_address" required>';
				$.confirm({
					title: '',
					content: content,
					buttons: {
						Cancel: {
						},
						Submit: {
							btnClass: 'btn-green',
							action: function () {
								 email_address = this.$content.find('.email_address').val();
								 if(email_address == '') {
									 $.alert({
										title: 'Error',
										type: 'red',
										content: 'Please enter an email address',
										buttons: {
											OK: function () {
											},
										}
									 });
									 return false;
								 }else{
								 	self.postSaveForLater(item_id, email_address)
								 }
							}
						}
					}
				});
			}else{
				self.postSaveForLater(item_id)
			}
		},

		postSaveForLater: function(item_id, email_address = null) {
			axios.post('/ajax/saveForLater', {
				item_id: item_id,
				email_address: email_address
			})
			.then(response => {
				// refresh the basket (item should have been removed)
				this.getBasketContents();
				this.getTotals();
				this.$store.commit('updateMinicartRefreshStatus', true);

				if (response.data.status == 'success') {
					this.working_saved_list = response.data.saved_list;
					$.alert({
						title: 'Great!',
						content: response.data.msg,
						buttons: {
							OK: function () {
							},
						}
					});
				}
				if (response.data.status == 'error') {
					$.alert({
						title: 'Error',
						type: 'red',
						content: response.data.msg,
						buttons: {
							OK: function () {
							},
						}
					});
				}
			})
			.catch(error => {
				console.log(error);
			});
		},

		moveToBasket: function(item) {
			this.addToBasket(item.variation, item.quantity);
			this.removeFromSavedList(item.id);
		},

		removeFromSavedList: function(item_id) {
			axios.post('/ajax/removeFromSavedList', {
				item_id: item_id,
			})
			.then(response => {
				if (response.data.status == 'success') {
					this.working_saved_list = response.data.saved_list;
				}
				if (response.data.status == 'error') {
					$.alert({
						title: 'Error',
						type: 'red',
						content: response.data.msg,
						buttons: {
							OK: function () {
							},
						}
					});
				}
			})
			.catch(error => {
				console.log(error);
			});
		}

	}

};
</script>
